import type {
  Page,
  PartnerProduct,
  PartnerProductDetails,
} from '@setplex/tria-api'
import { nay } from '~/shared/helpers'
import { getLabelPrice } from '~/shared/tools'
import type {
  PartnerProductDetailsFormatted,
  PartnerProductFormatted,
  PartnerProductGrid,
  PartnerProductRowFormatted,
} from './index.h'

export function formatPartnerProductRow(
  partnerProductPage: Page<PartnerProduct>
): PartnerProductRowFormatted {
  return {
    ...partnerProductPage,
    content: partnerProductPage.content.map(formatPartnerProductItem),
    isMoreThanOnePage: nay(partnerProductPage.last),
  }
}

export function formatPartnerProductGrid(
  partnerProductPage: Page<PartnerProduct>
): PartnerProductGrid {
  return {
    ...partnerProductPage,
    content: partnerProductPage.content.map(formatPartnerProductItem),
  }
}

export function formatPartnerProductItem(
  partnerProduct: PartnerProduct
): PartnerProductFormatted {
  return {
    ...partnerProduct,
    labelPrice: getPartnerProductLabelPrice(partnerProduct),
  }
}

export function formatPartnerProductDetailsItem(
  partnerProduct: PartnerProductDetails
): PartnerProductDetailsFormatted {
  return {
    ...partnerProduct,
    labelPrice: getPartnerProductLabelPrice(partnerProduct),
  }
}

function getPartnerProductLabelPrice(
  partnerProduct: PartnerProductDetails | PartnerProduct
) {
  const { rented, isActive, purchaseInfo, minPrice, minCurrency, free } =
    partnerProduct

  return (rented || free) && !isActive
    ? ''
    : getLabelPrice({
        purchaseInfo,
        minPrice,
        minCurrency,
        free,
      })
}
